import React, { Component } from 'react'
import { imageAddress } from '../../utils/useful'

export default class VoiceCall extends Component {
    state = {
        voicecall: { profile: '/assets/images/avatar-voice-call.jpg', name: 'Corey Culhane' }
    }
    answer = () => {

    }
    reject = () => {

    }
    render() {
        let voicecall = this.state.voicecall
        return (
            <div className='voice-call flexcc br-20 blur-bg box-shadow-widgets p-2'>
                <div className='flexcb w-100'>
                    <div className='flexcc'>
                        <div className='img-container br-10'>
                            <img className='br-15 w-100 h-100' src={imageAddress(voicecall.profile, 'profile')} alt="" />
                        </div>
                        <div className='mld-3'>
                            <p className='font-size-15 weight-500' style={{ color: "#555", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", maxWidth: "140px" }}>{voicecall.name}</p>
                            <p className='font-size-10 color-green mt-1'>Incoming voice Call</p>
                        </div>
                    </div>
                    <div className='flexc'>
                        <button className='flexcc' onClick={() => this.reject()}>
                            <img width={35} height={35} className='br-50 mx-2' src="/assets/icons/widgets/end-call.svg" alt="" />
                        </button>
                        <button className='flexcc' onClick={() => this.answer()}>
                            <img width={35} height={35} className='br-50' src="/assets/icons/widgets/call.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}
